import React from "react";
import PropTypes from "prop-types";
import withOver, { appAlert } from "lib/withOver";
import { SearchModule } from "lib/dataentry/lib/search/SearchModule";
import Dispatcher from "Dispatcher";
import MergeStore from "data/MergeStore";
import StereotypesStore from "data/StereotypesStore";
import SearchFormStore from "data/SearchFormStore";
import SuperRecordStore from "data/SuperRecordStore";
import { getAutoMergeGlobalSummary } from "data/util/merge/mergeHelpers";
import TableStore from "data/TableStore";
import DrawerLayoutJS from "lib/common/drawer/DrawerLayoutJS";
import SearchResultStore from "data/SearchResultStore";
import MergeActions from "data/MergeActions";
import SearchFormActions from "data/SearchFormActions";
import GlobalMergeBody from "./GlobalMergeBody";
import useFluxStore from "@armus/use-flux-store";

export class MergeComponent extends React.Component {
    render() {
        const {
            layout,
            searchForm,
            body
        } = this.props;
        return (
            <DrawerLayoutJS
                enabled={layout.enabled}
                open={!layout.enabled || layout.open}
                onDrawerToggle={layout.onToggle}
                drawerContent={
                    <SearchModule {...searchForm } />
                }
                content={body ? <GlobalMergeBody {...body} /> : null}
            />
        );
    }
}

MergeComponent.propTypes = {
    layout: PropTypes.shape({
        enabled: PropTypes.bool.isRequired,
        open: PropTypes.bool.isRequired,
        onToggle: PropTypes.func,
    }).isRequired,
    searchForm: PropTypes.object.isRequired,
    body: PropTypes.object,
};

export const GlobalMergeModuleContainer = props => {
    const {fluxContext, search, onSearch} = props;
    const state = useFluxStore(() => {
        const searchKey = SearchFormStore.getKey(fluxContext);
        const mergeState = MergeStore.getState();
        const stereotypes = StereotypesStore.getMergeStereotypes();
        const selectedStereotype = StereotypesStore.getStereotypeByKey(searchKey);
        const sorts = SearchFormStore.getSorts(fluxContext);
        const results = search.key
            ? SearchResultStore.getSearchLO(
                search.key,
                search.query,
                search.order,
            ).getValue() // null is fine.
            : null;
        const state = {
            layout: {
                enabled: mergeState.source != null,
                open: mergeState.modalParams.drawerOpen,
                onToggle: () => {
                    Dispatcher.dispatch({
                        type: MergeActions.TOGGLE_DRAWER,
                    });
                },
            },
            searchForm: {
                // search form props
                fluxContext: fluxContext,
                stereotypes: stereotypes,
                showAdvanced: true,
                title: `Find a ${selectedStereotype.name} to Merge From`,
                selectedStereotype: selectedStereotype,
                onStereotypeSelect: key => {
                    Dispatcher.contextDispatch(fluxContext, {
                        type: SearchFormActions.SELECT_STEREOTYPE,
                        key: key,
                    });
                },
                onSearch: () => {
                    onSearch();
                },
                showEmptySearchAlert: () => {
                    appAlert("Search requires at least one criterion.");
                },
                menuItemOnClick: () => {
                    /* noop */
                },
                // search result props

                records: results && results.results
                    ? results.results.filter(r => mergeState.target.id !== r.id)
                    : null,
                columns: selectedStereotype.fields,
                sorts: sorts,
                pagination: {
                    // Currently some paging values can not be trusted from the
                    // results. Instead we are using the SearchFormStore's values
                    // until there is a need to fix the values from the server.
                    page: SearchFormStore.getPage(fluxContext),
                    pageCount: results && results.pageCount, // cant be trusted
                    pageSize: SearchFormStore.getPageSize(fluxContext),
                    totalResultCount: results && results.totalResultCount, // cant be trusted.
                },
                selectedRecord: mergeState.source ? {id: mergeState.source.id} : null,
                supportsEnablement: selectedStereotype.supportsEnablement,
                showDisabled: selectedStereotype.supportsEnablement,
                showCreate: false,
                onRecordSelection: (record) => {
                    const key = record.key;
                    const id = record.id;
                    withOver("Loading...", () =>
                        SuperRecordStore.getRecordLO(key, id, true)
                            .promise()
                        .then(() =>
                            Dispatcher.contextDispatch(fluxContext, {
                                type: MergeActions.SELECT_SOURCE,
                                source: {
                                    stereoKey: key,
                                    id,
                                },
                            }))
                        .catch(jqXHR => {
                            if (jqXHR.status < 500) return;
                            console.error(
                                `error loading source record ${key}#${id}`,
                                jqXHR,
                            );
                            let msg = "Unable to load source record";
                            if (jqXHR.responseText !== "") {
                                try {
                                    const resp = JSON.parse(jqXHR.responseText);
                                    msg = resp.message;
                                } catch (error) {
                                    /* noop */
                                }
                            }
                            return appAlert(msg);
                        }));
                },
                onSort: (sortBy) => {
                    Dispatcher.contextDispatch(fluxContext, {
                        type: SearchFormActions.SORT,
                        key: sortBy.key,
                    });
                },
            },
        };

        if (mergeState.source) {
            const {source, target} = MergeStore.getProxyPair();
            state.body = {
                isMagicRoot: target.stereoInfo.magicRoot,
                mergePlugin: props.mergePlugin,
                onMerge: props.onMerge,
                onCancel: props.onCancel,
                fluxContext: fluxContext,
                target,
                source,
                sourceChildren: getAutoMergeGlobalSummary(mergeState.source)
            };
        }

        return state;
    }, [
        TableStore,
        SearchFormStore,
        MergeStore,
        SearchResultStore, // for global lists...
    ], [fluxContext, search, onSearch]);
    return <MergeComponent {...state} />;
};

GlobalMergeModuleContainer.propTypes = {
    fluxContext: PropTypes.string.isRequired,
    mergePlugin: PropTypes.string.isRequired,
    search: PropTypes.shape({
        key: PropTypes.string,
        query: PropTypes.string,
        order: PropTypes.string,
    }).isRequired,
    onMerge: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/merge/views/global-merge/GlobalMergeContainer.js